import Vue from 'vue';
import VueI18n from 'vue-i18n';
import zh from './zh';
import en from './en';

Vue.use(VueI18n);

const i18n = new VueI18n({
  // 本地无存储语言时，默认加载英文en
  locale: localStorage.getItem('lang') || 'en',
  messages: { zh, en },
});

export default i18n;
